<template>
<div v-if="sheba_numbers">
    <kt-row>
        <kt-col xs="12" sm="6" md="4" v-for="(bank_account, index) in bank_accounts"
        v-bind:key="index">
            <kt-panel>
                <kt-panel-body class="text-center shadow-sm">
                    <kt-row>
                        <kt-col xs="12" v-if="bank_account.shebaNumber">
                            {{ $t('panel.profile.bankAccount.shebaNumber') }} : {{ correctFormatSheba(bank_account.shebaNumber) }}
                        </kt-col>
                        <kt-col xs="12" v-if="bank_account.cardNumber">
                            {{ $t('panel.profile.bankAccount.cardNumber') }} :
                            {{ correctFormatCardNumber(bank_account.cardNumber) }}
                        </kt-col>
                        <kt-col xs="12" v-if="bank_account.accountNumber">
                            {{ $t('panel.profile.bankAccount.accountNumber') }} : {{bank_account.accountNumber}}
                        </kt-col>
                    </kt-row>
                    <span class="badge badge-primary">
                        {{ getBankName(correctFormatSheba(bank_account.shebaNumber)) }}
                    </span>
                </kt-panel-body>
            </kt-panel>
        </kt-col>
    </kt-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { userService } from '@/common/api.service'
import IranSheba from 'iran-sheba'

export default {
    data() {
        return {
            sheba_numbers: [],
            bank_accounts: {},
        }
    },
    computed: {
        ...mapGetters('user', [
            'user'
        ])
    },
    mounted() {
        userService.fetchShebaNumbers(this.user.id).then(
            response => {
                this.sheba_numbers = response.data.data
            }
        )
        userService.fetchBankAccounts(this.user.id).then(
            response => {
                this.bank_accounts = response.data.data
            }
        )
    },
    methods: {
        getBankName(number) {
            return IranSheba.recognize(number)['persianName']
        },
        correctFormatSheba(sheba) {
            return 'IR' + sheba.split('-').join('')
        },
        correctFormatCardNumber(cardNumber) {
            return cardNumber.split('-').join('')
        }
    }
}
</script>

<style>

</style>